import { render, staticRenderFns } from "./TagIcon.vue?vue&type=template&id=5547162e&scoped=true&"
import script from "./TagIcon.vue?vue&type=script&lang=js&"
export * from "./TagIcon.vue?vue&type=script&lang=js&"
import style0 from "./TagIcon.vue?vue&type=style&index=0&id=5547162e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5547162e",
  null
  
)

export default component.exports